import { NgModule } from '@angular/core';
import { provideConfig, RoutingConfig } from '@spartacus/core';

@NgModule({
  imports: [],
  providers: [
    provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          dealerSelection: { paths: ['dealer-selection'] },
          unitSelection: { paths: ['unit-selection'] },
        },
      },
    }),
  ],
})
export class PageRoutesModule {}
